export enum DamageRecentYears {
  NONE = "0",
  ONE = "1",
  TWO_OR_MORE = "2",
}
